import { type CSSProperties, memo, type ReactNode } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import { cn } from '@/lib/utils';

interface LoadingMoleculeProps {
  style?: CSSProperties;
  className?: string;
  transparent?: boolean;
  overlay?: boolean;
  children?: ReactNode;
  fullscreen?: boolean;
  showLoadingIcon?: boolean;
  slotProps?: {
    wrapper?: {
      className?: string;
    };
    indicator?: {
      className?: string;
      thickness?: number;
    };
  };
}

function LoadingComponent({
  style,
  className,
  transparent,
  overlay,
  children,
  fullscreen,
  showLoadingIcon = true,
  slotProps,
}: LoadingMoleculeProps) {
  return (
    <div
      className={cn(
        'absolute z-50 flex h-full w-full flex-col items-center justify-center bg-white',
        {
          'relative bg-transparent': transparent,
          'bg-gray-50/50': overlay,
          'fixed top-0 left-0 w-screen': fullscreen,
        },
        className
      )}
      style={style}
    >
      {showLoadingIcon && <CircularProgress {...slotProps?.indicator} />}
      {children && (
        <div
          className={cn('mt-5 text-primary/80', slotProps?.wrapper?.className)}
        >
          {children}
        </div>
      )}
    </div>
  );
}

const Loading = memo(LoadingComponent);
Loading.displayName = 'Loading';

export default Loading;
